import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './NavBar.css';
import NavDrawer from '../NavDrawer/NavDrawer';
import HamburgerMenu from '../HamburgerMenu/HamburgerMenu';
import "../../index.css"

const NavBar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > window.innerHeight * 0.75);
    };
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    // prevent background scroll when drawer open
    document.body.style.overflow = drawerOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [drawerOpen]);

  const handleLogoClick = () => {
    setDrawerOpen(false);
    navigate('/');
  };

  const handleNavigate = (path) => {
    setDrawerOpen(false);
    navigate(path);
  };

  return (
    <header className={`nav-bar ${scrolled ? 'nav-scrolled' : ''}`}>
      <div className="nav-inner">
        <button className="nav-logo" onClick={handleLogoClick} aria-label="home">
          <img src="/roseborne-logo-dark-shadow.png" alt="Roseborne Films Logo" />
        </button>

        <nav className="nav-links">
          <button onClick={() => handleNavigate('/')} className="nav-link clr-dark-red bold-p nav-link-shadow">Home</button>
          <button onClick={() => handleNavigate('/portrait')} className="nav-link clr-dark-red bold-p nav-link-shadow">Portraits</button>
          <button onClick={() => handleNavigate('/commercial')} className="nav-link clr-dark-red bold-p nav-link-shadow">Commercial</button>
        </nav>

        <div className="nav-hamburger">
          <HamburgerMenu clr={'clr-dark-red'} onClick={() => setDrawerOpen(true)} />
        </div>
      </div>

      <NavDrawer clr={'clr-dark-red'} open={drawerOpen} onClose={() => setDrawerOpen(false)} onNavigate={handleNavigate} />
    </header>
  );
};

export default NavBar;
